export function saveFile(body, filename, extension) {
  const blob = new Blob([body], { type: `application/${extension}` });
  const downloadUrl = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = `${filename}.${extension}`;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(downloadUrl);
}
